import { InputModal } from "Components/V1/InputModal"
import { CmbWithTitle } from "../../styled.components"
import { MenuFilterContainer } from "./styled.components"
import { useEffect, useState } from "react"
import ServiceArchivo from "service/archivos"
import { MenuItem } from "@mui/material"
import { format, parseISO } from "date-fns"
import { hotToast } from "utils"



const MenuFilter = ({ handleFilters }: any) => {
    const [arrayReportes, setArrayReportes] = useState<Array<any>>([])
    const [arrayMarcaOperacion, setArrayMarcaOperacion] = useState<Array<any>>([])
    const [data, setData] = useState<any>({
        idVista: '',
        idRelMarcaTipoOp: '',
        fechaInicio: '',
        fechaFin: ''
    })


    useEffect(() => {
        ServiceArchivo.cmbReporteUsuario(setArrayReportes );
        ServiceArchivo.cmbRelBrandOperation(setArrayMarcaOperacion );
    }, [])


    const handleChange = (e: any) => {
        let value = e.target.value;
        let name = e.target.getAttribute
            ? e.target.getAttribute("name")
            : e.target.name;

        if(name === "fechaFin" ){
            const $fechaFin = parseISO(value);
            const $fechaInicio = parseISO(data.fechaInicio);
            if($fechaFin < $fechaInicio){
                return hotToast("La fecha fin no puede ser menor a fecha inicial","ERROR");
            }
        }
        if(name === "fechaInicio" ){
            const $fechaFin = parseISO(data.fechaFin);
            const $fechaInicio = parseISO(value);
            if($fechaInicio > $fechaFin){
                return hotToast("La fecha inicio no puede ser mayor a fecha fin","ERROR");
            }
        }

        setData((old:any) => {
            const data = {
                ...old,
                [name]: value === 0 ? '' : value,
            }
            handleFilters(data)
            return data
        })
    }

    return (
        <MenuFilterContainer>
            <CmbWithTitle>
                <span>Reporte</span>
                <InputModal
                    name="idVista"
                    id="txtIdVista"
                    select
                    onChange={handleChange}
                /* value={} */
                >
                    <MenuItem value={0}>Ninguno</MenuItem>
                    {arrayReportes && arrayReportes.map((data: any, index: number) => (
                        <MenuItem key={index} value={data.value}>
                            {data.label}
                        </MenuItem>
                    ))}
                </InputModal>
            </CmbWithTitle>
            <CmbWithTitle>
                <span>Marca - T. Op</span>
                <InputModal
                    name="idRelMarcaTipoOp"
                    id="txtIdRelMarcaTipoOp"
                    select
                    onChange={handleChange}
                /* value={} */
                >
                    <MenuItem value={0}>Ninguno</MenuItem>
                    {arrayMarcaOperacion && arrayMarcaOperacion.map((data: any, index: number) => (
                        <MenuItem key={index} value={data.value}>
                            {data.label}
                        </MenuItem>
                    ))}
                </InputModal>
            </CmbWithTitle>
            <CmbWithTitle>
                <span>Fecha inicio</span>
                <InputModal
                    name="fechaInicio"
                    id="txtFechaInicio"
                    type="date"
                    onChange={handleChange}
                    value={data.fechaInicio}
                />
            </CmbWithTitle>
            <CmbWithTitle>
                <span>Fecha fin</span>
                <InputModal
                    name="fechaFin"
                    id="txtFechaFin"
                    type="date"
                    onChange={handleChange}
                    value={data.fechaFin}
                />
            </CmbWithTitle>
        </MenuFilterContainer>
    )
}

export default MenuFilter